{
  "feedback-emotion-page": {
    "text": {
      "title": "Your feedback",
      "subtitle": "Please help us to improve our service",
      "dissatisfied": "Dissatisfied",
      "on": "on",
      "neutral": "Neutral",
      "satisfaction-question": "Are you satisfied with our service?",
      "satisfied": "Satisfied",
      "thanks": "Thank you for your visit",
      "tip": "Tip: Click the face icon to show how satisfied you are with our service"
    }
  }
}
